var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content-wrapper pt-3"},[_c('div',{staticClass:"col-12"},[_c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }